import React, { useEffect, useState, JSX } from 'react';

import { getAuthUID, isAuthLoaded, onAuthReady } from '@/lib/authState';
import { useTenancy } from '@/contexts/TenancyContext';
import { useAuth } from '@/contexts/AuthContext';

import { getColumns } from '@/app/pages/policy-reader/components/columns';
import { DataTable } from '@/app/pages/policy-reader/components/data-table';

import { db, auth } from '@/lib/firebase';
import { collection, doc, getDoc, getDocs, updateDoc, setDoc, arrayUnion, arrayRemove, Timestamp as FirebaseTimestamp, serverTimestamp as FirebaseServerTimestamp, orderBy, query } from 'firebase/firestore';

import { getUserAssignedPolicies } from './components/service';
import { renderCtx } from '@/utils/ctxRenderer';
import HelpPopoverHover from '@/components/HelpPopoverHover';

const quizId = "9c9dgmkhcduQ4HS9zF9A";

const PolicyReader = () => {
  const { activeTenancy, userIdToName } = useTenancy();
  const { user } = useAuth();

  const [loading, setLoading] = useState(true);

  const [quizzes, setQuizzes] = useState<any[]>([]);



  useEffect(() => {
    try {
      getUserAssignedPolicies(user.uid, activeTenancy.id).then(setQuizzes);
    } finally {
      setLoading(false);
    }
  }, [user]);

  if (loading) return <p>Loading…</p>;

  return (
    <div className="page-container">
      <div className="glass-card">
        <div className="header-row flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="title flex flex-row">
              Policy Reader
              <span className="flex items-center bg-transparent pl-2 rounded font-semibold text-center">
                {/*<HelpPopoverHover config={helpContent?.['page.title']} />*/}
              </span>
            </h2>
            <p className="subtitle">
              These are the Policies that have been assigned to you. Read and take the quiz to completed them.
            </p>
          </div>
        </div>
        <DataTable columns={getColumns()} data={quizzes} />
      </div>
    </div>
  );
}

export default PolicyReader;
